export function removeDuplicates<T>(arr: T[], prop: keyof T): T[] {
	return arr.filter(
		(obj, index, self: T[]) =>
			index === self.findIndex((o) => o[prop] === obj[prop])
	)
}
